"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

import { inputs } from "./inputs.builder";

export const FindStoreBannerName = "Footer FindStoreBanner";

export const FindStoreBannerComponent: RegisteredComponent = {
  name: FindStoreBannerName,
  models: [getBuilderModelName("footer")],
  component: dynamic(
    async () => (await import("./FindStoreBanner")).FindStoreBanner
  ),
  inputs,
};
